// 관리자 계정 ID는 서버가 알려준다 (/api/auth/me, WebSocket initial_state)
let _adminId = '';

export const setAdminId = (id) => { if (id) _adminId = id; };

// 화면 표시용: 관리자 계정 닉네임은 "관리자"로 보여준다
export const isAdminUsername = (username) => !!_adminId && username === _adminId;
export const getDisplayName = (username) => (isAdminUsername(username) ? '관리자' : username);
